import smoothscroll from 'smoothscroll-polyfill';
import './Element.prototype.prepend';
import './Element.prototype.closest';

smoothscroll.polyfill();
